import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormControl } from '@angular/forms';

@Component({
    selector: 'app-checkbox',
    templateUrl: './checkbox.component.html',
    styleUrls: ['./checkbox.component.scss'],
    standalone: false,
})
export class CheckboxComponent {
    @Input() inputLabel: string;
    @Input() control: FormControl<boolean>;

    @Output() valueChange: EventEmitter<boolean> = new EventEmitter();

    onValueChange(): void {
        if (this.control.enabled) {
            this.valueChange.emit(this.control.value);
        }
    }
}
